<div class="modal-header">
  <h4 class="modal-title h1 pull-left">Receipt details</h4>
  <btn-close class="pull-right" (click)="modalRef.hide()"></btn-close>
</div>
<div class="modal-body" style="min-height: 100px">
    <table class="table table-bordered mb-0">
    <tr>
      <th>ID</th>
      <td>{{ item?.id }}</td>
    </tr>
    <tr>
      <th>Date created</th>
      <td>{{ item?.createdAt | moment }}</td>
    </tr>
    <tr>
      <th>Date updated</th>
      <td>{{ item?.updatedAt | moment }}</td>
    </tr>
    <tr>
      <th>Info</th>
      <td>{{ item?.value }}</td>
    </tr>
  </table>
  <preloader [hidden]="!loaderService.isLoading"></preloader>
</div>
<div class="modal-footer border-0">
  <button class="btn btn-success px-4" (click)="modalRef.hide()">
    OK
  </button>
</div>
